import React from "react";
import TableRow from "./TableRow";

const Table = () => {
  const contents = [
    {
      section: "PREFACE",
      name: "Pause",
      details: "An immersive and interactive experience.",
      page: "pause",
    },
    {
      section: "INTRO",
      name: "Introduction",
      details: "Welcome and introduction to The Web-Sense.",
      page: "3",
    },
    {
      section: "PART 1",
      name: "Map of Being Overview",
      details: "What is the Map of Being and why is it important?",
      page: "4",
    },
    {
      section: "CHAPTER 1",
      name: "Unconscious Infinite Loop",
      details:
        "An Interactive Map demonstrating what occurs covertly in our every interaction.",
      page: "9",
    },
    {
      section: "CHAPTER 2",
      name: "Evolution of Persona",
      details:
        "An Interactive Map demonstrating where our conditioned reactive behaviors evolved from. ",
      page: "23",
    },
    {
      section: "PART 2",
      name: "Interventions",
      details:
        "Guided evidence-based interventions to intercept unconscious behavioral patterns. (Coming soon)",
      page: "37",
    },
    {
      section: "APPX",
      name: "Appendices",
      details: "Additional media, details and references.",
      page: "40",
    },
  ];

  const renderContents = () => {
    return contents.map((content, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <TableRow key={index} rowData={content} />
    ));
  };

  return <div className="contents-table">{renderContents()}</div>;
};

export default Table;
